export default import.meta.ROLLDOWN_FILE_URL_eFYIsSmeyrhcwpIB9baEFA